export enum RequestStatus {
	idle = "IDLE",
	loading = "LOADING",
	succeeded = "SUCCEEDED",
	failed = "FAILED",
}
